import { render, staticRenderFns } from "./FilterTab.vue?vue&type=template&id=01a384ea&"
import script from "./FilterTab.vue?vue&type=script&lang=js&"
export * from "./FilterTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a384ea')) {
      api.createRecord('01a384ea', component.options)
    } else {
      api.reload('01a384ea', component.options)
    }
    module.hot.accept("./FilterTab.vue?vue&type=template&id=01a384ea&", function () {
      api.rerender('01a384ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/shop/finder/components/FilterTab.vue"
export default component.exports